import { useState, useEffect, useContext } from "react";
import StorageCard from "../components/storage/StorageCard.jsx";
import FilterStorageModal from "../components/storage/FilterStorageModal";
import StorageTab from "../components/storage/StorageTab.jsx";
import useAxios from "../services/useAxios.tsx";
import Helmet from "react-helmet";
import { searchFunc } from "../utils/helperFunction";
import SearchInputContext from "../Search/SearchInput";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";

export default function StoragePage() {
  const { execute: findUsers } = useAxios("api2/Find_users");
  const { execute: storeHouse } = useAxios("api2/storehouse");
  const { searchInput, setInputData } = useContext(SearchInputContext);
  const [searchInventory, setSearchInventory] = useState([]);
  const [billContentSearch, setBillContentSearch] = useState([]);
  const [users, setUsers] = useState([]);
  const [inventoryContent, setInventoryContent] = useState([]);
  const [billContent, setBillContent] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [filterModalShow, setFilterModalShow] = useState(false);
  const [billUpdater, setBillUpdater] = useState(false);
  const { userInfo } = useContext(AuthenticationContext);


  useEffect(() => {
    findUsers({ conditions: "type/=/1" }).then((data) => {
      let arr2 = [];
      for (let i = 0; i < data.length; i++) {
        let object = {};
        object.label = data[i].fname + " " + data[i].lname;
        object.value = data[i].id;
        arr2.push(object);
      }
      setUsers(arr2);
    });

    // storehouse
    storeHouse().then((data) => {
      setInventoryContent(data.whiteHouseItem);
      setSearchInventory(data.whiteHouseItem.reverse());

      setBillContent(data.checkInOut);
      setBillContentSearch(data.checkInOut.reverse());
    });
  }, [billUpdater]);

  // search
  useEffect(() => {
    let temp = searchFunc(
      searchInput,
      searchInventory.map((value) => {
        return { ...value, id: value?.p_service_id };
      })
    );
    let temp1 = searchFunc(
      searchInput,
      billContentSearch.map((value) => {
        return { ...value, id: value?.check_in_out__id };
      })
    );
    setInventoryContent(temp);
    setBillContent(temp1);
  }, [searchInput, filterData]);

  // filter
  const filter = () => {
    let fd = new FormData();
    if (filterData.selectedProduct?.length > 0) {
      fd.append(
        "p_services",
        filterData.selectedProduct?.map((val) => val.value).join(",")
      );
    }
    if (filterData.selectedUser?.length > 0) {
      fd.append(
        "users",
        filterData.selectedUser?.map((val) => val.value).join(",")
      );
    }
    if (filterData.dateIn?.length == 2) {
      fd.append("mtm_in", filterData.dateIn?.map((v) => v.unix).join(","));
    } else if (filterData.dateIn?.length == 1) {
      fd.append(
        "mtm_in",
        `${filterData.dateIn[0]?.unix},${filterData.dateIn[0]?.unix + 86400}`
      );
    }
    if (filterData.dateOut?.length == 2) {
      fd.append("mtm_out", filterData.dateOut?.map((v) => v.unix).join(","));
    } else if (filterData.dateOut?.length == 1) {
      fd.append(
        "mtm_out",
        `${filterData.dateOut[0].unix},${filterData.dateOut[0].unix + 86400}`
      );
    }
    if (filterData.inventory1 != "" && filterData.inventory2 != "") {
      fd.append(
        "inventory",
        `${filterData.inventory1},${filterData.inventory2}`
      );
    }
    // for (var [key, value] of fd.entries()) {
    //   console.log(key, value);
    // }
    storeHouse(fd).then((data) => {
      setInventoryContent(data.whiteHouseItem.reverse());
      setBillContent(data.checkInOut.reverse());
    });
    setFilterModalShow(false);
  };

  const removeFilter = () => {
    storeHouse().then((data) => {
      setInventoryContent(data.whiteHouseItem.reverse());
      setBillContent(data.checkInOut.reverse());
    });
    setFilterModalShow(false);
    setFilterData({
      selectedProduct: [],
      selectedUser: [],
      dateIn: [],
      dateOut: [],
      inventory1: "",
      inventory2: "",
    });
  };
  return (
    <>
      <Helmet>
        <title>انبار</title>
      </Helmet>
      {userInfo.userRoll.includes(36) && <StorageCard />}
      {userInfo.userRoll.includes(37) && (
        <FilterStorageModal
          filterData={filterData}
          setFilterData={setFilterData}
          removeFilter={removeFilter}
          filter={filter}
          users={users}
          filterModalShow={filterModalShow}
          setFilterModalShow={setFilterModalShow}
          setInputData={setInputData}
        />
      )}
      {userInfo.userRoll.includes(38) && (
        <StorageTab
          billContent={billContent}
          inventoryContent={inventoryContent}
          users={users}
          // setBillUpdater={setBillUpdater}
          setUpdater={setBillUpdater}
        />
      )}
    </>
  );
}
